







import axios from 'axios'
import {Component, Vue} from "vue-property-decorator"

@Component({})
export default class About extends Vue {
    test() {
        axios.post('https://b24-b8b2qj.bitrix24.ru/rest/crm.deal.list.json', {
            auth: 'db298b5e0045f2320045f23000000001201c0311b3dca07e4298bd09c7671bca0314bb',
            order: { "STAGE_ID": "ASC" },
            filter: { "ID": 2 },
            select: [ "ID", "TITLE", "STAGE_ID", "PROBABILITY", "OPPORTUNITY", "CURRENCY_ID" ]
        })
    }
}
